import Slider from "react-slick";
import { Render } from "../../../../../../../../homepage/Render";
import "./StoreComboCourses.scss";
import { useState } from "react";
import ComboCourses from "../../../../modal/ComboCourses/ComboCourses";

export const StoreComboCourses = (props) => {
  const { packageData } = props;
  const [comboCoursesDetails, setComboCoursesDetails] = useState(null);
  const [showComboCoursesDetails, setShowComboCoursesDetails] = useState(false);

  const comboSettings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 9000,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const openComboCoursesDetails = (data) => {
    setComboCoursesDetails(data);
    setShowComboCoursesDetails(true);
  };

  const closeComboCoursesDetails = () => setShowComboCoursesDetails(false);

  return (
    <div>
      <Render if={packageData?.length > 0}>
        <div className="combocourses-inner-wrapper">
          <div className="combocourses-content-and-btn-wrapper">
            <h3>Combo Course includes</h3>
            <div className="combocourses-content-wrapper">
              <Slider {...comboSettings}>
                {packageData?.map((item) => (
                  <div key={item.package_id} className="combocourses-content">
                    <div className="combocourses-heading">
                      <img src={item.icon} alt={item.title} />
                      <div className="combocourses-title">{item.title}</div>
                      <p className="combocourses-description">
                        {item?.description?.split(" ").slice(0, 20).join(" ") +
                          (item?.description?.split(" ").length > 20
                            ? "..."
                            : "")}
                      </p>
                      <div
                        className="combocourses-footer"
                        onClick={() => openComboCoursesDetails(item)}
                      >
                        View details
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </Render>
      <Render if={showComboCoursesDetails}>
        <ComboCourses
          handleClose={closeComboCoursesDetails}
          comboCoursesDetails={comboCoursesDetails}
        />
      </Render>
    </div>
  );
};
